import { IPortalQuestion } from './types';

export const convertQuestion = (data: IPortalQuestion<string>): IPortalQuestion<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
});
